import React from 'react';

const AngleDown = () => {

  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 89.88 49.487500000000004"><g><g><path d="M43.31,39.18l-.13-.08a3.36,3.36,0,0,1-.33-.2L1.33,7A3.42,3.42,0,0,1,.71,2.22l.68-.88A3.41,3.41,0,0,1,6.17.71L44.94,30.49,83.71.71a3.41,3.41,0,0,1,4.79.63l.68.88A3.42,3.42,0,0,1,88.55,7L47,38.9a3.36,3.36,0,0,1-.33.2l-.13.08a3.34,3.34,0,0,1-.45.2l-.18.07a3.39,3.39,0,0,1-.41.1l-.25,0H44.6l-.25,0a3.39,3.39,0,0,1-.41-.1l-.18-.07A3.34,3.34,0,0,1,43.31,39.18Z"/></g></g></svg>
    </>
  );
};

export default AngleDown;
